<template>
  <div>
    <v-container style="direction: rtl">
      <v-img
          :src="cphllogo"
          height="200"
          contain></v-img>
      <div class="logotext">
        مختبر الصحة العامة المركزي
      </div>

      <div class="logotext2">
        نظام معلومات غربلة الاطفال حديثي الولادة
      </div>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "Dashboard",

  data: function() {
    return {
      cphllogo: 'assets/cphl-logo.png',
    }
  }
}
</script>

<style scoped>
.logotext {
  text-align: center;
  font-weight: bold;
  color: black;
  font-size: 2.2rem;
}


.logotext2 {
  text-align: center;
  font-weight: normal;
  font-size: 2rem;
  color: #676767;
}
</style>